import {UserRole} from "@/shared/enums/UserRolesEnums";
import AssistedLivingCoachingList from "@/views/App/Analytics/ActiveCoachingHistory/AssistedLivingCoaching/List.vue";


const routesAnalyticsActiveCoachingHistory = [
    {
        path: "assisted-living-coaching-list",
        name: "analyticsActiveCoachingHistoryAssistedLivingCoachingList",
        component: AssistedLivingCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    }
]

export default routesAnalyticsActiveCoachingHistory;